import { render, staticRenderFns } from "./TheAsideBarMenu.vue?vue&type=template&id=868e4f88&"
import script from "./TheAsideBarMenu.vue?vue&type=script&lang=js&"
export * from "./TheAsideBarMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheAsideBarMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports